import React, { useEffect, useState } from "react";
import { getPublicSiteTextsApiPath } from "../../utils/publicSiteConfigPaths";
import { PUBLIC_SITE_TEXT_DEFAULTS } from "../../hooks/usePublicSiteTexts";

const FIELD_LABELS = {
  heroTitle: "Título del hero (página principal)",
  heroSubtitle: "Subtítulo del hero",
  coursesSectionTitle: "Título de la sección de cursos",
  coursesCtaLabel: "Texto del botón «Ver todos los cursos»",
  benefitsTitle: "Título de beneficios",
  benefit1Title: "Beneficio 1: título",
  benefit1Description: "Beneficio 1: descripción",
  benefit2Title: "Beneficio 2: título",
  benefit2Description: "Beneficio 2: descripción",
  benefit3Title: "Beneficio 3: título",
  benefit3Description: "Beneficio 3: descripción",
  benefit4Title: "Beneficio 4: título",
  benefit4Description: "Beneficio 4: descripción",
  learningTitle: "Bloque explicativo: título",
  learningDescription: "Bloque explicativo: descripción",
  learningHighlight: "Bloque explicativo: texto destacado",
  howItWorksTitle: "Título «Cómo funciona»",
  step1Title: "Paso 1: título",
  step1Description: "Paso 1: descripción",
  step2Title: "Paso 2: título",
  step2Description: "Paso 2: descripción",
  step3Title: "Paso 3: título",
  step3Description: "Paso 3: descripción",
  step4Title: "Paso 4: título",
  step4Description: "Paso 4: descripción",
  testimonialsTitle: "Testimonios: título",
  testimonialsFallbackText: "Testimonios: texto por defecto",
  testimonialsFallbackAuthor: "Testimonios: autor por defecto",
  ctaTitle: "Título del llamado a la acción final",
  ctaSubtitle: "Texto del llamado a la acción final",
  ctaButtonLabel: "Texto del botón final",
};

const TEXTAREA_FIELDS = new Set([
  "heroSubtitle",
  "benefit1Description",
  "benefit2Description",
  "benefit3Description",
  "benefit4Description",
  "learningDescription",
  "learningHighlight",
  "step1Description",
  "step2Description",
  "step3Description",
  "step4Description",
  "testimonialsFallbackText",
  "ctaSubtitle",
]);

function TextoPublico() {
  const [texts, setTexts] = useState(PUBLIC_SITE_TEXT_DEFAULTS);
  const [mensaje, setMensaje] = useState("");
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const res = await fetch(getPublicSiteTextsApiPath(), { credentials: "include" });
        if (!res.ok) {
          setError(`No se pudieron cargar los textos públicos (${res.status}).`);
          return;
        }
        const data = await res.json();
        setTexts({ ...PUBLIC_SITE_TEXT_DEFAULTS, ...data });
      } catch {
        setError("No se pudieron cargar los textos públicos.");
      }
    })();
  }, []);

  const onChange = (key, value) => {
    setTexts((prev) => ({ ...prev, [key]: value }));
  };

  const handleSave = async () => {
    setSaving(true);
    setMensaje("");
    setError("");
    try {
      const res = await fetch(getPublicSiteTextsApiPath(), {
        method: "PUT",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(texts),
      });
      const data = await res.json();
      if (!res.ok) {
        setError(data.error || "No se pudieron guardar los textos.");
        return;
      }
      setTexts({ ...PUBLIC_SITE_TEXT_DEFAULTS, ...data.textoPublico });
      setMensaje("Textos públicos guardados correctamente.");
    } catch {
      setError("Error de conexión al guardar.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <section className="cfgx-section">
      <h2>Textos de la parte pública</h2>
      <p className="cfgx-help">
        Edita los textos visibles en la página principal y secciones relacionadas sin modificar código.
      </p>
      {Object.keys(FIELD_LABELS).map((key) => (
        <div className="cfgx-field" key={key}>
          <label htmlFor={`public-text-${key}`}>{FIELD_LABELS[key]}</label>
          {TEXTAREA_FIELDS.has(key) ? (
            <textarea
              id={`public-text-${key}`}
              className="cfgx-textarea"
              rows={3}
              value={texts[key]}
              onChange={(e) => onChange(key, e.target.value)}
            />
          ) : (
            <input
              id={`public-text-${key}`}
              type="text"
              className="cfgx-input"
              value={texts[key]}
              onChange={(e) => onChange(key, e.target.value)}
            />
          )}
        </div>
      ))}
      {error ? <p className="cfgx-error">{error}</p> : null}
      {mensaje ? <p className="cfgx-msg">{mensaje}</p> : null}
      <button type="button" className="cfgx-btn-guardar" onClick={handleSave} disabled={saving}>
        {saving ? "Guardando…" : "Guardar textos públicos"}
      </button>
    </section>
  );
}

export default TextoPublico;
